import { lazy } from "react"
import { OysterRouter } from "~/router/type"
import { PermissionProtectedRoute } from "~/router/outlets/PermissionProtectedRoute"

const ServiceAgreementPage = lazy(
  () => import("../pages/ServiceAgreementPage/ServiceAgreementPage"),
)

export const companyMonetizationRoutes: OysterRouter = {
  "fullscreen-shell.center-align.alt-background": [
    {
      element: <PermissionProtectedRoute permissions={["hiring_progress"]} />,
      children: [
        {
          path: "hires/:employmentStrongId/service-agreement",
          element: <ServiceAgreementPage />,
        },
      ],
    },
  ],
}
